import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'

const INSTAGRAM_URL = 'https://www.instagram.com/resactly/'

export async function openInstagram(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    // In the mobile app: open via Capacitor Browser (App Store safe)
    await Browser.open({ url: INSTAGRAM_URL })
  } else {
    // On web: open in a new tab, keeping the app tab intact
    window.open(INSTAGRAM_URL, '_blank', 'noopener,noreferrer')
  }
}

